import { statusBarUtil } from '@qnpm/q-design-utils';
/**
 * 计算容器样式
 *  - 容器高度0~100
 * @param perHeight
 */
export const getContentStyle = (perHeight) => {
    const wrapperStyle = {
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        paddingBottom: statusBarUtil.getBottomBarHeight(),
        paddingTop: 0,
        overflow: 'hidden'
    };
    // 自定义
    if (perHeight === 'auto') {
        return Object.assign({ maxHeight: '80%', minHeight: '40%' }, wrapperStyle);
    }
    // 大于等于100时添加statusBar高度的paddingTop
    if (perHeight >= 100) {
        // eslint-disable-next-line no-param-reassign
        perHeight = 100;
        wrapperStyle.paddingTop = statusBarUtil.getStatusBarHeight();
    }
    // 如果传入参数小于0，则重置为0
    if (perHeight < 0) {
        // eslint-disable-next-line no-param-reassign
        perHeight = 0;
    }
    // 设置高度
    wrapperStyle.height = `${perHeight}%`;
    return wrapperStyle;
};
